import { FormField, FormSelect } from '../../../common/form';
import { DefaultOptionType } from 'rc-select/lib/Select';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSystemClassifiers } from '../../../configuration/useSystemClassifiers';
import {
  AlgorithmTargetMappingSourceOption,
  AlgorithmTargetMappingTargetOption,
} from './ruleOptions/types';

interface SourceMappingOption extends DefaultOptionType {
  dimensionCode?: string;
}

interface AlgorithmTargetItemSourceMappingSelectProps {
  label: string;
  index: number;
  options: AlgorithmTargetMappingSourceOption[];
}

const filterOption = (
  input: string,
  option?: AlgorithmTargetMappingTargetOption,
) =>
  (option?.codeName?.toString() ?? '')
    .toLowerCase()
    .includes(input.toLowerCase());

export function AlgorithmTargetItemSourceMappingSelect({
  label,
  index,
  options,
}: AlgorithmTargetItemSourceMappingSelectProps) {
  const { setValue } = useFormContext();
  const name = `rules.${index}.sourceItem` as const;

  const {
    DATA_SUBJECT_ATTRIBUTE: { systemClassifierItems: dataSubjectAttributes },
  } = useSystemClassifiers('DATA_SUBJECT_ATTRIBUTE');

  const handleChange = useCallback(
    (
      value: string | number | null,
      option: SourceMappingOption | SourceMappingOption[],
    ) => {
      const selected = Array.isArray(option) ? option[0] : option;
      setValue(
        `rules.${index}.subjectFieldCodeId`,
        dataSubjectAttributes.find(
          (subject) => subject.code === selected?.classifierCode,
        )?.id ?? null,
        { shouldDirty: true },
      );
    },
    [dataSubjectAttributes, index, setValue],
  );

  return (
    <FormField
      required
      size="large"
      label={label}
      name={name}
      style={{ minWidth: 0 }}
    >
      <FormSelect
        allowClear
        showSearch
        name={name}
        options={options}
        onChange={handleChange}
        filterOption={filterOption}
        className="nodrag nopan"
      />
    </FormField>
  );
}
